import { render, staticRenderFns } from "./CityRankings.vue?vue&type=template&id=07b4d83b&scoped=true&"
import script from "./CityRankings.vue?vue&type=script&lang=js&"
export * from "./CityRankings.vue?vue&type=script&lang=js&"
import style0 from "./CityRankings.vue?vue&type=style&index=0&id=07b4d83b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b4d83b",
  null
  
)

export default component.exports